import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

export default function SelectDay({ callback, value, width ,name, border, placeholder }) {

    const customStyles = makeDarkSelectStyles({ width: width || '100px', border });


    const days_array = range(1, 31);

    function range(start, end) {
        var foo = [];
        for (var i = start; i <= end; i++) {
            foo.push(i);
        }
        return foo;
    }
    var options = []
    Array.from(days_array, (e, i) => {
        var option = null;
        option = {
            label: days_array[i],
            value: i+1
        }
        options.push(option)
    })

    const handleSelect = (e) => {
        value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Day"}
                    value={options && options.filter(obj => obj.value == value)}


                />
            </div>

        </>
    )
}
